export function objectEntries<Value, Key extends string>(
  object: Partial<Record<Key, Value>>,
) {
  return Object.entries(object) as Array<[Key, Value]>;
}
